import React from 'react';
import { CircularProgress } from '@mui/material';

const Loader = () => (
    <div className="hrb-progress-container" style={{ paddingTop: 30 }}>
        <CircularProgress className="hrb-progress" />
    </div>
);

export default Loader;